import { io, type Socket } from "socket.io-client";
import { getApiBaseUrl } from "@/lib/api-client/config";

/**
 * One connection for the tab, opened lazily.
 *
 * Rooms are per-job and per-task, so several views subscribe at once; giving
 * each its own connection would multiply handshakes and defeat the server's
 * per-socket authorization cache. The socket authenticates from the access
 * cookie, which is why `withCredentials` is not optional here.
 */
let shared: Socket | null = null;

export function getSocket(): Socket {
  if (shared) return shared;
  const base = new URL(
    getApiBaseUrl() || window.location.origin,
    window.location.origin,
  );
  shared = io(base.origin, {
    path: `${base.pathname.replace(/\/$/, "")}/socket.io`,
    withCredentials: true,
    transports: ["websocket"],
    reconnectionDelay: 2_000,
    reconnectionDelayMax: 10_000,
  });
  return shared;
}

/** Drops the connection — used when the session ends, and by tests. */
export function closeSocket(): void {
  shared?.close();
  shared = null;
}
